import axios from "axios";
import { setAlert } from "./alert";
import {
  USER_LOADED,
  AUTH_ERROR,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  PASSWORD_SUCCESS,
  PASSWORD_SUCCESS_ERROR,
  LOGIN_SUCCESS_SUBADMIN,
  SUB_USER_LOADED,
  SUBADMIN_AUTH_ERROR,
  SUBADMIN_LOGIN_FAIL,
  SUBADMIN_LOGOUT,
  CLIENT,
  ALLEVENTS,
  ALLFILTEREDEVENTS,
  SET_LOADING,
  SIDEBAR_TOGGLE,
} from "./types";
import setAuthToken from "../utils/setAuthToken";
import { Token } from "aws-sdk";
import { json } from "body-parser";

// Load User
export const loadToken = (clientData) => async (dispatch) => {
  dispatch({
    type: CLIENT,
    payload: clientData,
  });
};
export const loadUser = (clientData) => async (dispatch) => {
  setAuthToken(localStorage.token);
  try {
    const res = await axios.get(
      process.env.REACT_APP_SITE_URL + "/v2/adminLogin"
    );
    // dispatch({
    //   type: CLIENT,
    //   payload:clientData
    // });
    return (
      res.data,
      dispatch({
        type: USER_LOADED,
        payload: res.data,
      })
    );
  } catch (err) {
    dispatch({
      type: AUTH_ERROR,
    });
  }
};
export const checkLinkExpiry = (user_id) => async (dispatch) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_SITE_URL +
        `/v2/adminLogin/link-expiry-check/${user_id}`
    );
    // dispatch({
    //   type: CLIENT,
    //   payload:clientData
    // });
    // return (
    //   res.data,
    //    dispatch({
    //   type: USER_LOADED,
    //   payload: res.data
    // })
    // )
    return res.data;
  } catch (err) {
    // dispatch({
    //   type: AUTH_ERROR
    // });
    return 0;
  }
};
// Load User
export const loadAllUsers = (page, sort, limit) => async (dispatch) => {
  try {
    console.log(sort, "sort");
    const res = await axios.get(
      process.env.REACT_APP_SITE_URL +
        `/v2/adminLogin/usersRecord/${page}?sort=${sort}&limit=${limit}`
    );
    console.log(res, "myres");
    return res.data;
    //   dispatch({
    //   type: USER_LOADED,
    //   payload: res.data
    // });
  } catch (err) {
    return 0;
  }
};

// Dashboard_Bar_API apis added by Mansi Vaghela
export const Dashboard_Bar_API = (page) => async (dispatch) => {
  try {
    const res = await axios.get(
      //
      process.env.REACT_APP_SITE_URL + `/v2/adminLogin/dashboard/users-chart`
    );
    console.log(res, "myres");
    return res.data;
    //   dispatch({
    //   type: USER_LOADED,
    //   payload: res.data
    // });
  } catch (err) {
    return 0;
  }
};

// Dashboard_Filter_API apis added by Mansi Vaghela
export const Dashboard_Filter_API = (month, year, week) => async (dispatch) => {
  try {
    const res = await axios.get(
      //
      process.env.REACT_APP_SITE_URL +
        `/v2/adminLogin/dashboard/users-chart?month=${month}&&year=${year}&&week${week}`
    );
    console.log(res, "myres");
    return res.data;
    //   dispatch({
    //   type: USER_LOADED,
    //   payload: res.data
    // });
  } catch (err) {
    return 0;
  }
};

// IDMerit_List_API apis added by Mansi Vaghela
export const IDMerit_List_API = (page, limit) => async (dispatch) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_SITE_URL +
        `/v2/adminLogin/IDMeritList/${page}/${limit}`
    );
    console.log(res, "myres");
    return res.data;
    //   dispatch({
    //   type: USER_LOADED,
    //   payload: res.data
    // });
  } catch (err) {
    return 0;
  }
};

// IDMerit_Search_API apis added by Mansi Vaghela
export const IDMerit_Search_API = (search, page, limit) => async (dispatch) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_SITE_URL +
        `/v2/adminLogin/IDMeritList/search/${search}/${page}/${limit}`
    );
    console.log(res, "myres");
    return res.data;
    //   dispatch({
    //   type: USER_LOADED,
    //   payload: res.data
    // });
  } catch (err) {
    return 0;
  }
};

// IDMerit_Filter_API apis added by Mansi Vaghela
export const IDMerit_Filter_API = (search, page, limit) => async (dispatch) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_SITE_URL +
        `/v2/adminLogin/IDMeritList/search/${search}/${page}/${limit}`
    );
    console.log(res, "myres");
    return res.data;
    //   dispatch({
    //   type: USER_LOADED,
    //   payload: res.data
    // });
  } catch (err) {
    return 0;
  }
};

// IDMtrust_List_API apis added by Mansi Vaghela
export const IDMtrust_List_API =
  (page, limit, sortkey, direction) => async (dispatch) => {
    try {
      const res = await axios.get(
        process.env.REACT_APP_SITE_URL +
          `/v2/adminLogin/IDMtrustList/${page}/${limit}?sortField=${sortkey}&sortDirection=${direction}`
      );
      console.log(res, "myres");
      return res.data;
      //   dispatch({
      //   type: USER_LOADED,
      //   payload: res.data
      // });
    } catch (err) {
      return 0;
    }
  };

//Edit IDMtrust_Edit_API Code added by mansi vaghela
export const IDMtrust_Edit_API = (id, city) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  const body = city;
  try {
    const res = await axios.post(
      process.env.REACT_APP_SITE_URL + `/v2/adminLogin/IDMtrustUpdate/${id}`,
      body,
      config
    );
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;

    return errors;
  }
};

//Edit IDMtrust_Search_API Code added by mansi vaghela
export const IDMtrust_Search_API =
  (search, page, limit, sortkey, direction) => async (dispatch) => {
    try {
      const res = await axios.get(
        process.env.REACT_APP_SITE_URL +
          `/v2/adminLogin/IDMtrustList/search/${search}/${page}/${limit}?sortField=${sortkey}&sortDirection=${direction}`
      );
      return res?.data;
      //   dispatch({
      //   type: USER_LOADED,
      //   payload: res.data
      // });
    } catch (err) {
      return 0;
    }
  };

//IDMtrust_Filter_API Code added by mansi vaghela
export const IDMtrust_Filter_API =
  (filter, page, limit, sortkey, direction) => async (dispatch) => {
    try {
      const res = await axios.get(
        process.env.REACT_APP_SITE_URL +
          `/v2/adminLogin/IDMtrustList/search/${filter}/${page}/${limit}?sortField=${sortkey}&sortDirection=${direction}`
      );
      return res?.data;
      //   dispatch({
      //   type: USER_LOADED,
      //   payload: res.data
      // });
    } catch (err) {
      return 0;
    }
  };

//IDMTrust_Sorting_API Code added by mansi vaghela
export const IDMTrust_Sorting_API =
  (page, limit, sortkey, direction) => async (dispatch) => {
    try {
      const res = await axios.get(
        process.env.REACT_APP_SITE_URL +
          `/v2/adminLogin/IDMtrustList/${page}/${limit}?sortField=${sortkey}&sortDirection=${direction}`
      );
      return res?.data;
      //   dispatch({
      //   type: USER_LOADED,
      //   payload: res.data
      // });
    } catch (err) {
      return 0;
    }
  };

//Radar apis added by Mansi Vaghela
export const RaderAttendee_List = (page, sort) => async (dispatch) => {
  try {
    console.log(sort, "sort");
    const res = await axios.get(
      process.env.REACT_APP_SITE_URL +
        `/v2/adminLogin/RaderAttendeeList/${page}`
    );
    console.log(res, "myres");
    return res.data;
    //   dispatch({
    //   type: USER_LOADED,
    //   payload: res.data
    // });
  } catch (err) {
    return 0;
  }
};

//Radar apis added by Mansi Vaghela
export const RaderAttendee_search = (city, page) => async (dispatch) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_SITE_URL +
        `/v2/adminLogin/RaderAttendeeList/search/${city}/${page}`
    );
    console.log(res, "myres");
    return res.data;
    //   dispatch({
    //   type: USER_LOADED,
    //   payload: res.data
    // });
  } catch (err) {
    return 0;
  }
};

//Radar apis added by Mansi Vaghela
export const GetRadarList = (page, sort) => async (dispatch) => {
  try {
    console.log(sort, "sort");
    const res = await axios.post(
      process.env.REACT_APP_SITE_URL + `/v2/adminLogin/RadarList/${page}`
    );
    console.log(res, "myres");
    return res.data;
    //   dispatch({
    //   type: USER_LOADED,
    //   payload: res.data
    // });
  } catch (err) {
    return 0;
  }
};

//Add radar city code added by mansi
export const AddRadar = (city) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  const body = city;
  try {
    const res = await axios.post(
      process.env.REACT_APP_SITE_URL + `/v2/adminLogin/RadarAdd`,
      body,
      config
    );
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;

    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, "danger")));
    }
    return errors;
  }
};

//Edit radar city Code added by mansi vaghela
export const EditRadar = (city, id) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  const body = city;
  try {
    const res = await axios.post(
      process.env.REACT_APP_SITE_URL + `/v2/adminLogin/RadarEdit/${id}`,
      body,
      config
    );
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;

    // if (errors) {
    //   errors.forEach((error) => dispatch(setAlert(error.msg, "danger")));
    // }
    return errors;
  }
};

//ChangeStatus radar city Code added by mansi vaghela
export const ChangeStatus = (city, id) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  const body = city;
  try {
    const res = await axios.post(
      process.env.REACT_APP_SITE_URL + `/v2/adminLogin/RadarStatus/${id}`,
      body,
      config
    );
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;

    // if (errors) {
    //   errors.forEach((error) => dispatch(setAlert(error.msg, "danger")));
    // }
    return errors;
  }
};

export const SearchCity = (page, searchData) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  // const body = searchData;

  const body = {
    search: searchData,
  };
  try {
    const res = await axios.post(
      process.env.REACT_APP_SITE_URL + `/v2/adminLogin/RadarList/${page}`,
      body,
      config
    );
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, "danger")));
    }
    return errors;
  }
};

export const DeleteCity = (id) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.post(
      process.env.REACT_APP_SITE_URL + `/v2/adminLogin/RadarDelete/${id}`
    );
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;

    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, "danger")));
    }
    return errors;
  }
};

//Add Community radar city Code added by mansi vaghela
export const Add_Community = (city) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  const body = city;
  try {
    const res = await axios.post(
      process.env.REACT_APP_SITE_URL + `/v2/community/create-community`,
      body,
      config
    );
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;

    // if (errors) {
    //   errors.forEach((error) => dispatch(setAlert(error.msg, "danger")));
    // }
    return errors;
  }
};

//Community_List api added by mansi vaghela
export const Community_List =
  (status, page, limit, search, sort, sortfeild, StartDate, toDate) =>
  async (dispatch) => {
    try {
      const res = await axios.get(
        process.env.REACT_APP_SITE_URL +
          `/v2/community/adminCommunityList?status=${status}&page=${page}&limit=${limit}&search=${search}&sortOrder=${sort}&sortField=${sortfeild}&start_date=${StartDate}&end_date=${toDate}`
      );
      console.log(res, "myres");
      return res.data;
      //   dispatch({
      //   type: USER_LOADED,
      //   payload: res.data
      // });
    } catch (err) {
      return 0;
    }
  };

//Add communityList_Status api added by mansi vaghela
export const communityList_Status =
  (Community_id, status) => async (dispatch) => {
    try {
      const res = await axios.get(
        process.env.REACT_APP_SITE_URL +
          `/v2/community/update-status?community_id=${Community_id}&status=${status}`
      );
      console.log(res, "myres");
      return res.data;
      //   dispatch({
      //   type: USER_LOADED,
      //   payload: res.data
      // });
    } catch (err) {
      return 0;
    }
  };

//Add CommunityPost_Like API Code added by mansi vaghela
export const CommunityPost_Like = (city) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  const body = city;
  try {
    const res = await axios.post(
      process.env.REACT_APP_SITE_URL + `/v2/community/like-post`,
      body,
      config
    );
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;

    return errors;
  }
};

//Add CommunityPost_UnLike API Code added by mansi vaghela
export const CommunityPost_UnLike = (city) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
    data: city,
  };

  try {
    const res = await axios.delete(
      process.env.REACT_APP_SITE_URL + `/v2/community/unlike-post`,
      config
    );
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;
    return errors;
  }
};

// status=&page=1&limit=10&search=&sortOrder&sortField&start_date&end_date
//Request_Community_List api added by mansi vaghela
export const Request_Community_List =
  (page, limit, search, sort, sortfeild, StartDate, toDate) =>
  async (dispatch) => {
    try {
      const res = await axios.get(
        process.env.REACT_APP_SITE_URL +
          `/v2/community/requestCommunityList?page=${page}&limit=${limit}&search=${search}&sortOrder=${sort}&sortField=${sortfeild}&start_date=${StartDate}&end_date=${toDate}`
      );
      console.log(res, "myres");
      return res.data;
      //   dispatch({
      //   type: USER_LOADED,
      //   payload: res.data
      // });
    } catch (err) {
      return 0;
    }
  };

//Update_Community API added by mansi vaghela
export const Update_Community = (Data, id) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  const body = Data;
  try {
    const res = await axios.put(
      process.env.REACT_APP_SITE_URL + `/v2/community/update-community/${id}/`,
      body,
      config
    );
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;
    return errors;
  }
};

//Update_Community API added by mansi vaghela
export const Approve_communnity = (id) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const res = await axios.put(
      process.env.REACT_APP_SITE_URL + `/v2/community/acceptCommunity/${id}`,
      config
    );
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;
    return errors;
  }
};

//Reject_community API added by mansi vaghela
export const Reject_community = (id, reason) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  const body = reason;
  try {
    const res = await axios.put(
      process.env.REACT_APP_SITE_URL + `/v2/community/rejectCommunity/${id}`,
      body,
      config
    );
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;
    return errors;
  }
};

//Create_Post API added by mansi vaghela
export const Create_Post = (city) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  const body = city;
  try {
    const res = await axios.post(
      process.env.REACT_APP_SITE_URL + `/v2/community/create-post`,
      body,
      config
    );
    return res.data;
  } catch (err) {
    const errors = err.response.data.error;

    // if (errors) {
    //   errors.forEach((error) => dispatch(setAlert(error.msg, "danger")));
    // }
    return errors;
  }
};

//Community_List api added by mansi vaghela
export const Community_viewMembers =
  (page, limit, id, search, sort, sortfeild, StartDate, toDate) =>
  async (dispatch) => {
    try {
      const res = await axios.get(
        process.env.REACT_APP_SITE_URL +
          // `/v2/community/adminCommunityList?status=${status}&page=${page}&limit=${limit}&search=${search}&sortOrder=${sort}&sortField=${sortfeild}&start_date=${StartDate}&end_date=${toDate}`
          `/v2/community/adminViewMembers?page=${page}&limit=${limit}&community_id=${id}&search=${search}&sortorder=${sort}&fieldname=${sortfeild}&start_date=${StartDate}&end_date=${toDate}`
      );
      return res.data;
      //   dispatch({
      //   type: USER_LOADED,
      //   payload: res.data
      // });
    } catch (err) {
      return 0;
    }
  };

//GetAllPost api added by mansi vaghela
export const GetAllPost = (page, limit, id) => async (dispatch) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_SITE_URL +
        `/v2/userCommunity/getAllPost?page=${page}&limit=${limit}&community_id=${id}`
    );
    return res.data;
    //   dispatch({
    //   type: USER_LOADED,
    //   payload: res.data
    // });
  } catch (err) {
    return 0;
  }
};

export const DownloadExcel = (headers) => async (dispatch) => {
  const apiUrl = process.env.REACT_APP_SITE_URL + "/v2/adminLogin/download";

  const body = JSON.stringify({ headers });

  console.log("setAuthToken", localStorage.getItem("token"));
  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "x-auth-token": localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
      body: body,
    });

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    // Assuming the response is directly an Excel file, we can proceed to download it
    const blob = await response.blob();

    // Create a temporary URL to the blob
    const url = window.URL.createObjectURL(blob);

    // Create a hidden <a> element to trigger the download
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    a.download = "User Report.xls"; // Set the filename here
    document.body.appendChild(a);
    a.click(); // Trigger the download
    document.body.removeChild(a); // Clean up - remove the <a> element
    localStorage.setItem("loader", false);

    console.log("Excel file downloaded successfully");
  } catch (error) {
    console.error("Error downloading the Excel file:", error);
    localStorage.setItem("loader", false);
  } finally {
    localStorage.setItem("loader", false);

    dispatch({ type: SET_LOADING, payload: false }); // Replace setLoading with a dispatch action if necessary
  }
};

export const ExportIDMtrustExcel = () => async (dispatch) => {
  const url =
    process.env.REACT_APP_SITE_URL + "/v2/adminLogin/IDMtrustExportExcel";
  const token = localStorage.getItem("token");

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "x-auth-token": token,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    // Read response as a Blob
    const blob = await response.blob();

    // Create a temporary link to trigger file download
    const downloadLink = document.createElement("a");
    downloadLink.href = URL.createObjectURL(blob);
    downloadLink.download = "IDMtrust Export.xlsx"; // Set the file name
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);

    return "File downloaded successfully.";
  } catch (err) {
    console.error("Request failed:", err);
    return err.message;
  }
};
// Load Deleted User
export const loadAllDeletedUsers = (page, sort) => async (dispatch) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_SITE_URL +
        `/v2/adminLogin/usersRecord/deleted/${page}?sort=${sort}`
    );
    //console.log(res);
    return res.data;
    //   dispatch({
    //   type: USER_LOADED,
    //   payload: res.data
    // });
  } catch (err) {
    return 0;
  }
};

//users for dashboard

export const dashboardusers = () => async (dispatch) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_SITE_URL + "/v2/adminLogin/dashboard/users"
    );

    return res.data;
    //   dispatch({
    //   type: USER_LOADED,
    //   payload: res.data
    // });
  } catch (err) {
    return err;
  }
};

//Transactions for dashboard
export const dashboardTransactions = () => async (dispatch) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_SITE_URL + "/v2/adminLogin/dashboard/transactions"
    );

    return res.data;
    //   dispatch({
    //   type: USER_LOADED,
    //   payload: res.data
    // });
  } catch (err) {
    return err;
  }
};

// Load User
export const userDetail = (id) => async (dispatch) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_SITE_URL + `/v2/adminLogin/getUserDataa/${id}`
    );
    //console.log(res);
    return res.data;
    //   dispatch({
    //   type: USER_LOADED,
    //   payload: res.data
    // });
  } catch (err) {
    return 0;
  }
};

export const userDetailPage =
  (id, page, limit, searchValue) => async (dispatch) => {
    try {
      const res = await axios.get(
        process.env.REACT_APP_SITE_URL +
          `/v2/adminLogin/getUserDataa/${id}?page=${page}&limit=${limit}&searchText=${searchValue}`
      );
      //console.log(res);
      return res.data;
      //   dispatch({
      //   type: USER_LOADED,
      //   payload: res.data
      // });
    } catch (err) {
      return 0;
    }
  };

//pdf_invoice
export const Invoice_Download = (id) => async (dispatch) => {
  try {
    const response = await axios
      .get(
        process.env.REACT_APP_SITE_URL + `/v2/adminlogin/userInvoice/${id}`,
        { responseType: "blob" }
      )
      .then((response) => {
        const file = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(file);
        link.download = "invoiceFile.pdf"; // Set the file name
        link.click();
      })
      .catch((error) => {
        console.error("Error downloading the invoice:", error);
      });
    return response.data;
    //   dispatch({
    //   type: USER_LOADED,
    //   payload: res.data
    // });
  } catch (err) {
    return 0;
  }
};

// Load User
export const updateUserStatus = (id, userStatus) => async (dispatch) => {
  try {
    const res = await axios.put(
      process.env.REACT_APP_SITE_URL +
        `/v2/adminLogin/updateStatus/${id}/${userStatus}`
    );
    //console.log(res);
    return res.data;
    //   dispatch({
    //   type: USER_LOADED,
    //   payload: res.data
    // });
  } catch (err) {
    return 0;
  }
};
// Load User
export const search = (s, page, limit, sort) => async (dispatch) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_SITE_URL +
        `/v2/adminLogin/search/${s}/${page}?limit=${limit}&sort=${sort}`
    );
    //console.log(res);
    return res.data;
    //   dispatch({
    //   type: USER_LOADED,
    //   payload: res.data
    // });
  } catch (err) {
    return 0;
  }
};
// Search deleted User
export const searchdeleted = (s, page) => async (dispatch) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_SITE_URL +
        `/v2/adminLogin/searchdeleted/${s}/${page}`
    );
    //console.log(res);
    return res.data;
    //   dispatch({
    //   type: USER_LOADED,
    //   payload: res.data
    // });
  } catch (err) {
    return 0;
  }
};

// Load User
export const addCredits = (data) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.put(
      process.env.REACT_APP_SITE_URL + "/v2/front/manual_coins_addition",
      data,
      config
    );
    //console.log(res);
    return res.data;
    //   dispatch({
    //   type: USER_LOADED,
    //   payload: res.data
    // });
  } catch (err) {
    return 0;
  }
};

// Load User
export const loadAllUsersForSearch = () => async (dispatch) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_SITE_URL + `/v2/users/search_usersRecord`
    );
    //console.log(res);
    return res.data;
    //   dispatch({
    //   type: USER_LOADED,
    //   payload: res.data
    // });
  } catch (err) {
    return 0;
  }
};
// Load User
export const loadSubUser = () => async (dispatch) => {
  setAuthToken(localStorage.token);
  try {
    const res = await axios.get(
      process.env.REACT_APP_SITE_URL + "/v2/subadmin/login"
    );
    dispatch({
      type: SUB_USER_LOADED,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: SUBADMIN_AUTH_ERROR,
    });
  }
};

// Login User
export const adminLogin = (email, password) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const body = JSON.stringify({ email, password });

  try {
    const res = await axios.post(
      process.env.REACT_APP_SITE_URL + "/v2/adminLogin",
      body,
      config
    );

    dispatch({
      type: LOGIN_SUCCESS,
      payload: res.data,
    });

    dispatch(loadUser());
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;

    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, "danger")));
    }
    dispatch({
      type: LOGIN_FAIL,
    });
    return errors;
  }
};
// Login User
// Login User
export const forgotPassword = (email) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const body = JSON.stringify({ email });

  try {
    const res = await axios.post(
      process.env.REACT_APP_SITE_URL + "/v2/adminLogin/forgotPassword",
      body,
      config
    );

    // dispatch({
    //   type: LOGIN_SUCCESS,
    //   payload: res.data
    // });

    //dispatch(loadUser());
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;

    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, "danger")));
    }
    // dispatch({
    //   type: LOGIN_FAIL
    // });
    return errors;
  }
};
// Login User
export const changePassword = (formData) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.put(
      process.env.REACT_APP_SITE_URL + "/v2/adminLogin",
      formData,
      config
    );

    dispatch({
      type: PASSWORD_SUCCESS,
      payload: res.data,
    });

    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;

    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, "danger")));
    }
    dispatch({
      type: PASSWORD_SUCCESS_ERROR,
    });
    return errors;
  }
};

export const resetPassword = (user_id, formData) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.put(
      process.env.REACT_APP_SITE_URL +
        `/v2/adminLogin/change_password/${user_id}`,
      formData,
      config
    );

    dispatch({
      type: PASSWORD_SUCCESS,
      payload: res.data,
    });

    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;

    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, "danger")));
    }
    dispatch({
      type: PASSWORD_SUCCESS_ERROR,
    });
    return errors;
  }
};
// Logout / Clear Profile
export const logout = () => (dispatch) => {
  dispatch({ type: LOGOUT });
};
// Logout / Clear Profile
export const subadminlogout = () => (dispatch) => {
  dispatch({ type: SUBADMIN_LOGOUT });
};

export const toggle_Sidebar = () => (dispatch) => {
  console.log(SIDEBAR_TOGGLE, "toggle_Sidebartoggle_Sidebar");
  dispatch({ type: SIDEBAR_TOGGLE });
};
//Load All events
export const AllEvents = (page) => async (dispatch) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_SITE_URL +
        `/v2/adminLogin/allEventsListView/${page}`
    );
    console.log(res.data);
    // return dispatch({
    //   type: ALLEVENTS,
    //   payload: res.data
    // });
    return res.data;
  } catch (err) {
    return 0;
  }
};

//filtered Events
export const FilteredEvents = (page, status, title) => async (dispatch) => {
  try {
    if (status == 0 || status == "") {
      var apiUrl = `/v2/adminLogin/filterEvents/${page}?title=${title}`;
    } else {
      var apiUrl = `/v2/adminLogin/filterEvents/${page}?title=${
        title ? title : ""
      }&status=${status}`;
    }
    const res = await axios.get(process.env.REACT_APP_SITE_URL + apiUrl);
    console.log("requireddata", res.data);
    // return dispatch({
    //   type: ALLEVENTS,
    //   payload: res.data
    // });
    return res.data;
  } catch (err) {
    return 0;
  }
};

//setting events
export const EventDetailSetting = (id) => async (dispatch) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_SITE_URL +
        `/v2/adminLogin/singleEventDetailSettings/${id}`
    );
    console.log("requireddata", res.data);
    // return dispatch({
    //   type: ALLEVENTS,
    //   payload: res.data
    // });
    return res.data;
  } catch (err) {
    return 0;
  }
};

//Restrictions events
export const EventDetailRestrictions = (id) => async (dispatch) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_SITE_URL +
        `/v2/adminLogin/singleEventInvitedUsers/${id}`
    );
    console.log("requireddata", res.data);
    // return dispatch({
    //   type: ALLEVENTS,
    //   payload: res.data
    // });
    return res.data;
  } catch (err) {
    return 0;
  }
};

//Attendees events
export const EventDetailAttendees = (id, page) => async (dispatch) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_SITE_URL +
        `/v2/adminLogin/singleEventInvitedUsers/${id}`
    );
    console.log("requireddata", res.data);
    // return dispatch({
    //   type: ALLEVENTS,
    //   payload: res.data
    // });
    return res.data;
  } catch (err) {
    return 0;
  }
};

//Transaction event
export const EventDetailTransaction = (id) => async (dispatch) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_SITE_URL +
        `/v2/adminLogin/singleEventTransaction/${id}`
    );
    console.log("requireddata", res.data);
    // return dispatch({
    //   type: ALLEVENTS,
    //   payload: res.data
    // });
    return res.data;
  } catch (err) {
    return 0;
  }
};

// events by userid
export const EventsByuserId = (id, page, type, search) => async (dispatch) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_SITE_URL +
        `/v2/adminLogin/singleListEventsByid/${id}?page=${page}&limit=10&status=${type}&search=${
          search ? search : ""
        }`
    );
    console.log("requireddata", res.data);
    // return dispatch({
    //   type: ALLEVENTS,
    //   payload: res.data
    // });
    return res.data;
  } catch (err) {
    return 0;
  }
};

// reacieved ratings by userid
export const RecievedRatings =
  (id, page, statusFilter, search) => async (dispatch) => {
    try {
      const res = await axios.get(
        process.env.REACT_APP_SITE_URL +
          `/v2/adminLogin/singleUserReceivedRatings/${id}/${page}?status=${statusFilter}&search=${search}`
      );
      console.log("requireddata", res.data);
      // return dispatch({
      //   type: ALLEVENTS,
      //   payload: res.data
      // });
      return res.data;
    } catch (err) {
      return 0;
    }
  };

// given ratings by userid
export const GivensRatings =
  (id, page, filterval, search) => async (dispatch) => {
    try {
      const res = await axios.get(
        process.env.REACT_APP_SITE_URL +
          `/v2/adminLogin/singleUserGivenRatings/${id}/${page}?status=${filterval}&search=${search}`
      );
      console.log("requireddata", res.data);
      // return dispatch({
      //   type: ALLEVENTS,
      //   payload: res.data
      // });
      return res.data;
    } catch (err) {
      return 0;
    }
  };

// recieved ratings details by ratingid
export const RecievedRatingDetails = (id, page) => async (dispatch) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_SITE_URL +
        `/v2/adminLogin/singleRecivedRatingDetail/${id}`
    );
    console.log("requireddata", res.data);
    // return dispatch({
    //   type: ALLEVENTS,
    //   payload: res.data
    // });
    return res.data;
  } catch (err) {
    return 0;
  }
};

// Given ratings details by ratingid
export const RatingGivenDetails = (id, page) => async (dispatch) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_SITE_URL +
        `/v2/adminLogin/singleGivenRatingDetail/${id}`
    );
    console.log("requireddata", res.data);
    // return dispatch({
    //   type: ALLEVENTS,
    //   payload: res.data
    // });
    return res.data;
  } catch (err) {
    return 0;
  }
};

// Received falgs details by ratingid
export const RecievedFlagss = (id, page, search) => async (dispatch) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_SITE_URL +
        `/v2/adminLogin/singleUserReceivedFlags/${id}?pageNo=${page}&search=${search}`
    );
    console.log("requireddata", res.data);
    // return dispatch({
    //   type: ALLEVENTS,
    //   payload: res.data
    // });
    return res.data;
  } catch (err) {
    return 0;
  }
};

// given falgs details by ratingid
export const GivenFlagss = (id, search) => async (dispatch) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_SITE_URL +
        `/v2/adminLogin/singleUserGivenflag/${id}?pageNo=1&search=${search}`
    );
    console.log("requireddata", res.data);
    // return dispatch({
    //   type: ALLEVENTS,
    //   payload: res.data
    // });
    return res.data;
  } catch (err) {
    return 0;
  }
};

//Restrictions events
export const EventCancel = (id) => async (dispatch) => {
  try {
    const res = await axios.delete(
      process.env.REACT_APP_SITE_URL + `/v2/adminLogin/singleEventCancel/${id}`
    );
    console.log("requireddata", res.data);
    // return dispatch({
    //   type: ALLEVENTS,
    //   payload: res.data
    // });
    return res.data;
  } catch (err) {
    return 0;
  }
};

export const Delete_post = (id) => async (dispatch) => {
  try {
    const res = await axios.delete(
      process.env.REACT_APP_SITE_URL + `/v2/community/delete-post/${id}`
    );
    console.log("requireddata", res.data);
    // return dispatch({
    //   type: ALLEVENTS,
    //   payload: res.data
    // });
    return res.data;
  } catch (err) {
    return 0;
  }
};

export const Recievdrating = (id) => async (dispatch) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_SITE_URL +
        `/v2/adminLogin/singleRecivedRatingDetail/${id}`
    );
    // console.log("comingDAsta" , res)
    return res.data;
  } catch (err) {
    return 0;
  }
};

export const GivenRatingDetails =
  (id, filterStatus, searchval) => async (dispatch) => {
    try {
      const res = await axios.get(
        process.env.REACT_APP_SITE_URL +
          `/v2/adminLogin/singleGivenRatingDetail/${id}`
      );
      // console.log("comingDAsta" , res)
      return res.data;
    } catch (err) {
      return 0;
    }
  };
